import {Directive} from "@angular/core";

@Directive({
  selector: 'ng-template[intDropdownItem]'
})
export class IntDropdownItemDirective {

}
